import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';
// eslint-disable-next-line
import { AuthModule, BASE_PATH } from 'kfp';

@NgModule({
    imports: [AuthModule],
    providers: [{ provide: BASE_PATH, useValue: environment.apiUrl }],
    exports: [],
})
export class KfpModule {}
